import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';

const ArthiksakhasSthanShreniWiseSummary = () => {

  const { Id, Name } = useParams();
  // const [gurudakshinas, setGurudakshinas] = useState([]);
  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [summary, setSummary] = useState({});

  const [gurudakshinaFinalizationStatus, setGurudakshinasFinalizationStatus] = useState([]);
  const [FinalSubmissionList, setFinalSubmissionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinaPerPage = 50;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [selectedSakha, setSelectedSakha] = useState("");
  const [sakhaList, setSakhaList] = useState([]);
  const { auth } = useAuth();
  const [proudaSubmitted, setProudaSubmitted] = useState(false);
  const [vidyarthiSamyukthaSubmitted, setVidyarthiSamyukthaSubmitted] = useState(false);
  const [vidyarthiTharunaSubmitted, setVidyarthiTharunaSubmitted] = useState(false);
  const [vyavasayiTharunaSubmitted, setVyavasayiTharunaSubmitted] = useState(false);

  const [sakhaSubmitted, setSakhaSubmitted] = useState("");

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const errRef = useRef();

  const [Sthans, setSthans] = useState([]);
  const [khandList, setKhandList] = useState([]);
  const [selectedKhandId, setSelectedKhandId] = useState("");
  const [mandalamList, setMandalamList] = useState([]);
  const [selectedMandalamId, setSelectedMandalamId] = useState("");

  const [sthanList, setSthanList] = useState([]);
  const [selectedSthanId, setSelectedSthanId] = useState("");
  const [hasSearched, setHasSearched] = useState(false); // 👈 NEW

  useEffect(() => {
    const fetchSthanList = async () => {
      if (!selectedKhandId) {
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]); // clear table
        return;
      }


      try {
        const res = await axiosPrivate.get(`list-sthans?mandal_id=${selectedMandalamId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setSthanList(data);
        if (data.length > 0) {
          const firstSthanId = data[0].sthan_id;
          setSelectedSthanId("");  // force change
          setTimeout(() => {
            setSelectedSthanId(firstSthanId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedSthanId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load Sthan list");
        setSthanList([]);
        setSelectedSthanId("");
        // setSthans([]);
      }
    };

    fetchSthanList();
  }, [selectedMandalamId]);



  const fetchKhands = useCallback(async () => {
    if (!auth.level_id) return;


    // setSthans([]);
    try {
      const res = await axiosPrivate.get(`list-khands-in-arthik-sakha?arthik_sakha_id=${auth.level_id}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setKhandList(data);
      if (data.length > 0) {
        setSelectedKhandId(data[0].khand_id); // optional default
      } else {
        setSelectedKhandId("");
      }
    } catch (err) {
      console.error("Khand fetch failed:", err);
      setError("Failed to load Khand list");
      setKhandList([]);
      setSelectedKhandId("");
    }
  }, [axiosPrivate, auth.level_id]);

  useEffect(() => {
    if (auth.level_id) {
      fetchKhands();
    }
  }, [auth.level_id]);

  useEffect(() => {
    const fetchMandalamList = async () => {
      if (!selectedKhandId) {
        setMandalamList([]);
        setSelectedMandalamId("");
        // setSthans([]); // clear table
        return;
      }


      try {
        const res = await axiosPrivate.get(`list-mandals?khand_id=${selectedKhandId}`);
        const data = Array.isArray(res.data) ? res.data : [];
        setMandalamList(data);
        if (data.length > 0) {
          const firstMandalamId = data[0].mandal_id;
          setSelectedMandalamId("");  // force change
          setTimeout(() => {
            setSelectedMandalamId(firstMandalamId);  // re-trigger useEffect
          }, 0);
        } else {
          setSelectedMandalamId("");
          // setSthans([]); // clear table
        }

      } catch (err) {
        console.error("Sthan fetch failed:", err);
        setError("Failed to load mandals list");
        setMandalamList([]);
        setSelectedMandalamId("");
        setSthans([]);
      }
    };

    fetchMandalamList();
  }, [selectedKhandId]);



  // ✅ Modal state
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const handleCloseModal = () => setShowFinalizeModal(false);
  const handleShowModal = async () => {
    try {
      const response = await fetchFinalSubmissionList(); // your API function
      setShowFinalizeModal(true); // Open modal after success
    } catch (error) {
      console.error("Failed to fetch finalize data:", error);
      // Optionally show error toast or alert here
    }
  };

  const ClickAddGurudakshina = () => {
    navigate(`/arthikShakha/add/gurudakshina/${selectedSthanId}`);
  };
  const handleFinalize = () => {
    setShowFinalizeModal(false);    // Close first modal
    setShowSecondModal(true);       // Show second confirmation modal
  };

  const handleCloseSecondModal = () => setShowSecondModal(false);

  const fetchSakhaList = async () => {
    try {
      const res = await axiosPrivate.get('get-sakhas');
      setSakhaList(res.data);
    } catch (err) {
      console.error("Failed to fetch sakhas", err);
    }
  };

  useEffect(() => {
    fetchSakhaList();
  }, []);


  const fetchArppanSummary = useCallback(async () => {
    if (!selectedSthanId) return;  // 🛑 Prevent API call if undefined or empty
    setLoading(true);
    setError(null);
    setHasSearched(true);
    try {
      const url = `get-sthan-arppan-summary?sthan_id=${selectedSthanId}`;
      const response = await axiosPrivate.get(url, { withCredentials: true });
      setLoading(false);
      if (response.status === 204) {
        // ✅ No Content case
        setGurudakshinas([]);
        setLoading(false);
        setError("No Data available.");
        return;
      }

      // ✅ Handle valid data
      // setGurudakshinas(Array.isArray(response.data) ? response.data : []);
      setGurudakshinas(response.data);


    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setGurudakshinas([]); // Clear old data in case of error
      setLoading(false);
    }
  }, [axiosPrivate, selectedSthanId]);


  const summaryData = gurudakshinas?.data || [];

  const vs = summaryData.find(item => item.sakha === "Vidyarthi Samyuktha");
  const vt = summaryData.find(item => item.sakha === "Vidyarthi Tharuna");
  const vy = summaryData.find(item => item.sakha === "Vyavasayi Tharuna");
  const pr = summaryData.find(item => item.sakha === "Prouda");




  const fetchGurudakshinaFinalizationStatus = useCallback(async () => {
    if (!selectedSthanId || !selectedSakha) {
      // console.log("Skipping fetch: Missing selectedSthanId or selectedSakha", { selectedSthanId, selectedSakha });
      setGurudakshinasFinalizationStatus(null); // 🧹 Clear old data
      return;
    }

    setError(null);
    try {
      const response = await axiosPrivate.get(
        `gurudakshina-finalization-status?sthan_id=${selectedSthanId}&sakha=${selectedSakha}`,
        { withCredentials: true }
      );
      setGurudakshinasFinalizationStatus(response.data);


    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");

    }
  }, [axiosPrivate, selectedSakha, selectedSthanId]);




  const fetchFinalSubmissionList = useCallback(async () => {
    setError(null);
    try {
      const response = await axiosPrivate.get(`list-final-submissions?sthan_id=${selectedSthanId}`, {
        withCredentials: true,
      });

      const data = response.data;
      setFinalSubmissionList(data);


      data.forEach(item => {
        switch (item.sakha) {
          case "Prouda":
            setProudaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vidyarthi Samyuktha":
            setVidyarthiSamyukthaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vidyarthi Tharuna":
            setVidyarthiTharunaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vyavasayi Tharuna":
            setVyavasayiTharunaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          default:
            break;
        }
      });

    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
    }
  }, [axiosPrivate, selectedSthanId]);




  useEffect(() => {
    fetchArppanSummary();
    fetchGurudakshinaFinalizationStatus();
  }, [selectedSakha, selectedSthanId]);



  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // clear success message
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // clear error message
      setShowSuccessModal(true); // Show modal

      // Auto close after 10 seconds (10000 ms)
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 5000);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var data = JSON.stringify({
        sthan_id: selectedSthanId,
        sakha: sakhaSubmitted,
      });

      const response = await axiosPrivate.post(`update-final-submissions`, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      setShowSecondModal(false);
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }


  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinaPerPage);

  // if (loading) {
  //   return <div className="loading">Loading...</div>;
  // }

  return (
    <>
      <style>{`

/* Target only this table */
#customers tbody tr:nth-child(odd) {
  background-color: #ffffff !important; /* white */
}

#customers tbody tr:nth-child(even) {
  background-color: #ffffffff !important; /* light gray */
}

/* Optional hover effect */
#customers tbody tr:hover {
  background-color: #e6f7ff  !important; /* light blue */
}

      `}
      </style>

      <section className="empbody">
        <div className="wrapperemp2">
          {/* ✅ Finalize Button with Modal trigger */}

          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>


          <div className="d-flex justify-content-end align-items-center gap-2 mb-3">

            {/* {selectedSthanId && (
              <>
                <button onClick={ClickAddGurudakshina} type="button" className="btn btn-success ms-auto newviewbtn">
                  + Gurudakshina
                </button>
                <button onClick={handleShowModal} type="button" className="btn btn-warning newviewbtn">
                  Finalize
                </button>
              </>
            )} */}

          </div>

          <h3>Sthan Summary</h3>


          <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
            <Modal.Header closeButton>
              {/* <Modal.Title>Success</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <p>{sucssMsg}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setShowSuccessModal(false)}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
          <Row>



            <Col md={2}>
              <Form.Label className="newformstyle">Khand</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedKhandId}
                onChange={(e) => setSelectedKhandId(e.target.value)}
                disabled={!khandList.length}
              >
                <option value="">-- Select Khand --</option>
                {khandList.map((k) => (
                  <option key={k.khand_id} value={k.khand_id}>
                    {k.khand_name}
                  </option>
                ))}
              </Form.Select>

            </Col>

            <Col md={2}>
              <Form.Label className="newformstyle">Mandalam</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedMandalamId}
                onChange={(e) => {
                  const mandalamId = e.target.value;
                  setSelectedMandalamId(mandalamId); // Correctly set Mandalam ID
                  // Remove this:
                  // setSelectedKhandId(khandId);
                  // setMandalamList([]);
                  // setSthans([]);
                }}
                disabled={!mandalamList.length}
              >

                <option value="">-- Select Mandalam --</option>
                {mandalamList.map((m) => (
                  <option key={m.mandal_id} value={m.mandal_id}>
                    {m.mandal_name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={2}>
              <Form.Label className="newformstyle">Sthan</Form.Label>
              <Form.Select
                className="newselectstyle"
                value={selectedSthanId}
                onChange={(e) => {
                  const sthanId = e.target.value;
                  setSelectedSthanId(sthanId); // Correctly set Mandalam ID
                  // Remove this:
                  // setSelectedKhandId(khandId);
                  // setMandalamList([]);
                  // setSthans([]);
                }}
                disabled={!sthanList.length}
              >

                <option value="">-- Select Sthan --</option>
                {sthanList.map((m) => (
                  <option key={m.sthan_id} value={m.sthan_id}>
                    {m.sthan_name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={2}>

              <Form.Group controlId="pranthDropdown" className="mb-3">
                <Form.Label className="newformstyle">Ultsavam</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedSakha}
                  onChange={(e) => setSelectedSakha(e.target.value)}
                >
                  <option value="">-- Select Ultsavam --</option>
                  {sakhaList.map((sakha, index) => (
                    <option key={index} value={sakha}>{sakha}</option>
                  ))}
                </Form.Control>
              </Form.Group >
            </Col>

          </Row>


          <div className="table-container">


            <div className="newdivst">
              {gurudakshinaFinalizationStatus && gurudakshinaFinalizationStatus.sakha && (
                <Row>
                  <Col md={3}>
                    <p>Ultsavam : <span>{gurudakshinaFinalizationStatus.sakha}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Total Amount : <span>{gurudakshinaFinalizationStatus.amount}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Submitted Date : <span>{gurudakshinaFinalizationStatus.submitted_date}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Is Submitted : <span>{gurudakshinaFinalizationStatus.isSubmitted ? "Yes" : "No"}</span></p>
                  </Col>
                </Row>
              )}
            </div>
            {hasSearched && (
              <div className="table-container">
                {hasSearched && (
                  <table id="customers" className="table table-bordered text-center summary-table">
                    <thead>
                      <tr>
                        <th colSpan={1} className="text-center">
                          SHRENI
                        </th>
                        <th colSpan={5} className="text-center">
                          UPASTHITHI/THUKA
                        </th>
                      </tr>
                      <tr>
                        <th rowSpan={2}></th>
                        <th>VIDHYARTHI SAMYUKTHA</th>
                        <th>VIDHYARTHI THARUNA</th>
                        <th>VYAVASAYI THARUNA</th>
                        <th>PROUDA</th>
                        <th>TOTAL</th>
                      </tr>
                      <tr>
                        <th>({gurudakshinas?.vs_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.vt_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.vy_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.pr_uthsavam ?? 0})</th>
                        <th>({gurudakshinas?.uthsavam ?? 0})</th>
                      </tr>
                    </thead>

                    <tbody><tr>
                      <th>SISU</th>

                      <td>
                        <div>{vs?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vs?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>
                      </td>

                      <td>
                        <div> {vt?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vt?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>



                      </td>

                      <td>

                        <div> {vy?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(vy?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>


                      </td>

                      <td>
                        <div> {pr?.sisu ?? 0}</div>
                        <div className="amount">
                          ₹{Number(pr?.sisuAmount ?? 0).toLocaleString("en-IN")}
                        </div>



                      </td>

                      <td>
                        {(vs?.sisu ?? 0) +
                          (vt?.sisu ?? 0) +
                          (vy?.sisu ?? 0) +
                          (pr?.sisu ?? 0)}
                        <br />
                        ₹
                        {(
                          Number(vs?.sisuAmount ?? 0) +
                          Number(vt?.sisuAmount ?? 0) +
                          Number(vy?.sisuAmount ?? 0) +
                          Number(pr?.sisuAmount ?? 0)
                        ).toLocaleString("en-IN")}
                      </td>
                    </tr>
                      <tr>
                        <th>BALA</th>

                        <td>
                          {vs?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.bala ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.balaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.bala ?? 0) +
                            (vt?.bala ?? 0) +
                            (vy?.bala ?? 0) +
                            (pr?.bala ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.balaAmount ?? 0) +
                            Number(vt?.balaAmount ?? 0) +
                            Number(vy?.balaAmount ?? 0) +
                            Number(pr?.balaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>

                      <tr>
                        <th>VIDHYARTHI THARUNA</th>

                        <td>
                          {vs?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.vtharuna ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.vtharuna ?? 0) +
                            (vt?.vtharuna ?? 0) +
                            (vy?.vtharuna ?? 0) +
                            (pr?.vtharuna ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.vtharunaAmount ?? 0) +
                            Number(vt?.vtharunaAmount ?? 0) +
                            Number(vy?.vtharunaAmount ?? 0) +
                            Number(pr?.vtharunaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>

                      <tr>
                        <th>VYAVASAYI THARUNA</th>

                        <td>
                          {vs?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.tharuna ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.tharuna ?? 0) +
                            (vt?.tharuna ?? 0) +
                            (vy?.tharuna ?? 0) +
                            (pr?.tharuna ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.tharunaAmount ?? 0) +
                            Number(vt?.tharunaAmount ?? 0) +
                            Number(vy?.tharunaAmount ?? 0) +
                            Number(pr?.tharunaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                      <tr>
                        <th>PROUDA</th>

                        <td>
                          {vs?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vs?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vt?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vt?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {vy?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(vy?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {pr?.prouda ?? 0}
                          <div className="amount">
                            ₹{Number(pr?.proudaAmount ?? 0).toLocaleString("en-IN")}
                          </div>
                        </td>

                        <td>
                          {(vs?.prouda ?? 0) +
                            (vt?.prouda ?? 0) +
                            (vy?.prouda ?? 0) +
                            (pr?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.proudaAmount ?? 0) +
                            Number(vt?.proudaAmount ?? 0) +
                            Number(vy?.proudaAmount ?? 0) +
                            Number(pr?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                      <tr>
                        <th>TOTAL</th>

                        <td>
                          {(vs?.sisu ?? 0) +
                            (vs?.bala ?? 0) +
                            (vs?.vtharuna ?? 0) +
                            (vs?.tharuna ?? 0) +
                            (vs?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.sisuAmount ?? 0) +
                            Number(vs?.balaAmount ?? 0) +
                            Number(vs?.vtharunaAmount ?? 0) +
                            Number(vs?.tharunaAmount ?? 0) +
                            Number(vs?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vt?.sisu ?? 0) +
                            (vt?.bala ?? 0) +
                            (vt?.vtharuna ?? 0) +
                            (vt?.tharuna ?? 0) +
                            (vt?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vt?.sisuAmount ?? 0) +
                            Number(vt?.balaAmount ?? 0) +
                            Number(vt?.vtharunaAmount ?? 0) +
                            Number(vt?.tharunaAmount ?? 0) +
                            Number(vt?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vy?.sisu ?? 0) +
                            (vy?.bala ?? 0) +
                            (vy?.vtharuna ?? 0) +
                            (vy?.tharuna ?? 0) +
                            (vy?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vy?.sisuAmount ?? 0) +
                            Number(vy?.balaAmount ?? 0) +
                            Number(vy?.vtharunaAmount ?? 0) +
                            Number(vy?.tharunaAmount ?? 0) +
                            Number(vy?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(pr?.sisu ?? 0) +
                            (pr?.bala ?? 0) +
                            (pr?.vtharuna ?? 0) +
                            (pr?.tharuna ?? 0) +
                            (pr?.prouda ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(pr?.sisuAmount ?? 0) +
                            Number(pr?.balaAmount ?? 0) +
                            Number(pr?.vtharunaAmount ?? 0) +
                            Number(pr?.tharunaAmount ?? 0) +
                            Number(pr?.proudaAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>

                        <td>
                          {(vs?.totalUpasthith ?? 0) +
                            (vt?.totalUpasthith ?? 0) +
                            (vy?.totalUpasthith ?? 0) +
                            (pr?.totalUpasthith ?? 0)}
                          <br />
                          ₹
                          {(
                            Number(vs?.totalAmount ?? 0) +
                            Number(vt?.totalAmount ?? 0) +
                            Number(vy?.totalAmount ?? 0) +
                            Number(pr?.totalAmount ?? 0)
                          ).toLocaleString("en-IN")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            )}
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div >
      </section >

      <Modal show={showFinalizeModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          <div className="modstyle">
            <center>
              <h6>Which you want to finalize?</h6>
              <table className="table table-bordered mt-3" id="customers">
                <tbody>
                  <tr>
                    <td>Vidyarthi Samyuktha</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Vidyarthi Samyuktha");
                          handleFinalize();
                        }}
                        disabled={vidyarthiSamyukthaSubmitted} // button will be disabled when this is true
                      >
                        {vidyarthiSamyukthaSubmitted ? "Already Finalized" : "Finalize"}

                      </Button>


                    </td>
                  </tr>
                  <tr>
                    <td>Vidyarthi Tharuna</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Vidyarthi Tharuna");
                          handleFinalize();
                        }}
                        disabled={vidyarthiTharunaSubmitted} // button will be disabled when this is true
                      >
                        {vidyarthiTharunaSubmitted ? "Already Finalized" : "Finalize"}
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td>Vyavasayi Tharuna</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Vyavasayi Tharuna");
                          handleFinalize();
                        }}
                        disabled={vyavasayiTharunaSubmitted} // button will be disabled when this is true
                      >
                        {vyavasayiTharunaSubmitted ? "Already Finalized" : "Finalize"}
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td>Prouda</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Prouda");
                          handleFinalize();
                        }}
                        disabled={proudaSubmitted} // button will be disabled when this is true
                      >
                        {proudaSubmitted ? "Already Finalized" : "Finalize"}
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>



              <Button className="tbnewbtncl" onClick={handleCloseModal}>Close</Button>

              <p className="newmodalheadp">ശ്രദ്ധിക്കുക!.</p>
              <p className="newmodalp">ഓരോ ശാഖയുടെയും തുക പരിശോധിച്ച് ഉറപ്പുവരുത്തിയതിനു ശേഷം മാത്രം FINALIZE ചെയ്യുക.
                FINALIZE ചെയ്‌തു കഴിഞ്ഞ ശാഖ യുടെ ഗുരുദക്ഷിണ ലിസ്റ്റിൽ താങ്കൾക്ക് മാറ്റം വരുത്താൻ സാധിക്കുകയില്ല.</p>
            </center>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={showSecondModal} onHide={handleCloseSecondModal} centered>
        {/* <Modal.Header closeButton>
    <Modal.Title>Finalize Confirmation</Modal.Title>
  </Modal.Header> */}
        <Modal.Body>
          <div className="modstyle">
            <center>
              <h6>Do you want to finalize <span className="colorChange">{sakhaSubmitted}</span>?</h6>
              <p className="newmodalp2">FINALIZE ചെയ്ത്‌തു കഴിഞ്ഞ ശാഖ യുടെ ഗുരുദക്ഷിണ ലിസ്റ്റിൽ താങ്കൾക്ക് മാറ്റം വരുത്താൻ സാധിക്കുകയില്ല.</p>

              <Button className="newbtn2" onClick={handleCloseSecondModal}>
                No
              </Button>
              <Button className="newbtn" onClick={handleSubmit}>
                Yes
              </Button>
            </center>
          </div>

        </Modal.Body>

      </Modal>


      <TopBar />
    </>
  );
};

export default ArthiksakhasSthanShreniWiseSummary;
